<template>
    <div class="tl-row">
        <div class="tl-columnheader">
            <h2 class="tl-tit">시공지 유형 <span class="color-red">*</span></h2>
        </div>
        <div class="tl-cell">
            <div class="check-block-container">
                <label class="check-block" v-for="category in categories" :key="category._id">
                    <input type="checkbox" class="input" :value="category._id" :checked="category._id === input" @click="setCategoryChild" />
                    <span class="button button--border-primary">{{ category.name }}</span>
                </label>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        input: String || null,
        categories: Array,
    },
    methods: {
        setCategoryChild(event) {
            this.$emit("set-input", { _category: event.target.value });
        },
    },
};
</script>
